<template>
  <div class="routeMap_container">
    <span class="icon_container"
      ><i class="fa fa-th" aria-hidden="true"></i
    ></span>
    <div class="map_routes">
      <ul v-if="mapRoutes != []" class="route_list">
        <div
          v-for="(route, index) in mapRoutes"
          :key="index"
          class="route_item"
        >
          <li v-if="route.query">
            <router-link
              :to="{ name: route.path , query:{id:route.query.id , title:route.query.title } }"
              :class="{ active: route.path }"
              >{{ route.name }}</router-link
            >
          </li>
          <li v-else-if="route.path">
            <router-link
              :to="{ name: route.path }"
              :class="{ active: route.path }"
              >{{ route.name }}</router-link
            >
          </li>
          <li v-else-if="route.length>1" :class="{ logic: route.node === logic}" >
                <button @click="multiScene = !multiScene" class="dropbtn">Multi-Scenes 
                <i class="fa fa-caret-down"></i>
                </button>
              <div v-if="multiScene" class="dropdown-content">
                  <a @click="goToNode(nextnode.realNode)" class="scene" v-for="(nextnode, index) in route" :key="index"> {{ nextnode.name.replace(/([a-z])(\d)/gi, '$1 $2') }}</a>
              </div>
          </li>

          <li v-else @click="goToNode(route.realNode)" :class="{ scene: route.node === scene, logic: route.node === logic, page: route.node === page, linkNodes: !route.next && route.thereNext === true, mainNodeIsScene: route.main && route.node === scene, mainNodeIsLogic: route.main && route.node === logic, mainNodeIsPage: route.main && route.node === page, }" >
            {{ route.name == "Dashboard" ? route.name : "" }}
            {{ route.name }}
          </li>

          <span
            v-if="$route.name != route.path && mapRoutes[index + 1]"
            class="arrow"
          ></span>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import { db } from "../../firebaseDB";
export default {
  data() {
    return {
      scene: 'Scene',
      SceneNode: "SceneNode",
      logic: 'Logic',
      page: 'Page',
      multiScene: false,
    }
  },
  props: {
    mapRoutes: Array,
  },
  methods: {
    goToNode(data){
      db.ref(`stories/` + localStorage.getItem("storyId") )
        .once('value')
        .then((snapshot) => {
      let storyData = snapshot.val()
     const nodeDataArray = storyData.diagram.nodeDataArray
      const nodePosition = nodeDataArray.findIndex((n) => n.key == data.key);
       const nodedata = nodeDataArray.filter((n) => n.key == data.name)[0];
      let selectedNode = {
        key: nodedata.key,
        name: nodedata.key,
        category: nodedata.category,
        nodePosition: nodePosition,
      };
      localStorage.setItem("selectedLogic", JSON.stringify(selectedNode));
      this.$store.dispatch("listUserStories");
      if (data && data.name.startsWith("Logic")) {
        this.$router.push("logicEditView");
      } else {
        if(this.$router.currentRoute.name!='storyEditView'){
        this.$router.push("storyEditView");
        }else{
         this.$router.go(this.$router.currentRoute)
        }
      }
    })
    }
  },
  watch: {
    '$route' (to, from) {
      this.$store.commit('setCurrentPageRoute', this.mapRoutes.slice(-1)[0])
      console.log(this.$store.state.currentPageRoute);
    }
  }
};
</script>

<style lang="scss" scoped>

li {
  cursor: default;
}

.routeMap_container {
  display: flex;
  align-items: center;
  background-color: transparent;
  padding-top: 1rem;

}
.icon_container {
  display: none;
  padding: 0.5rem 1.7rem 0.5rem 0.5rem;
  // padding: .3rem;
  border-radius: 0.2rem 0 0 0.2rem;
  background-color: #EEBA2E;
  color: #000000;
  position: relative;
  border: 2px solid #ffffff;
  border-right: none;

  // &::before {
  //   content: "";
  //   position: absolute;
  //   right: 0;
  //   top: -1px;
  //   width: 37.3333%;
  //   height: 55%;
  //   border: 1px solid #ffffff;
  //   border-right: none;
  //   border-top: 1px solid #EEBA2E;
  //   background-color: #262626;
  //   border-radius: 0 0 0 100%;
  // }
  // &::after {
  //   content: "";
  //   position: absolute;
  //   background-color: #262626;
  //   right: 0;
  //   bottom: -2px;
  //   border-radius: 0 0 0 100%;
  //   width: 35.3333%;
  //   height: 58%;
  //   border: 1px solid #ffffff;
  //   border-right: 1px solid #EEBA2E;
  //   border-top: none;
  //   transform: rotate(90deg);
  // }
}

.route_list {
  list-style: none;
  display: flex;
  align-items: center;
  //background-color: #262626;
  //border: 1px solid #EEBA2E;
  // border-left: none;
  padding: 0.65rem 0;
  margin: 0;
  border-radius:  0.7rem 20px 20px 0.7rem;
  position: relative;
  left: -0.5px;
  &::before {
    // content: "";
    position: absolute;
    left: -1.1rem;
    top: -1px;
    width: 16px;
    height: 54%;
    background-color: #262626;
    border-radius: 0 0 0 100%;
    border: 2px solid #fff;
    border-right: none;
    border-top: 1px solid #EEBA2E;
  }
  &::after {
    // content: "";
    position: absolute;
    left: -1.1rem;
    bottom: -1px;
    width: 16px;
    height: 54%;
    background-color: #262626;
    border-radius: 100% 0 0 0;
    border: 2px solid #fff;
    border-right: none;
    border-bottom: 1px solid #EEBA2E;
  }
  .route_item {
    display: flex;
    align-items: center;
  }

  a {
    text-decoration: none;
    color: #333;
  }

  li {
    padding-right: 1rem;
    padding-left: 1rem;
    font-size: 0.9rem;
    font-weight: 300;
  }
}

.active {
  position: relative;
  color: #EEBA2D !important;
  font-weight: 500;
}

.mainNodeIsScene {
  color: #E83B94 !important;
}

.mainNodeIsLogic {
  color: #8debd2 !important;
}

.mainNodeIsPage {
  color: #FFA500 !important;
}

.linkNodes {
  position: relative;

  &::after {
    content: '';
    position: absolute;
    width: 30px;
    height: 2px;
    top: 50%;
    right: -20px;
    background: #bfbfbf;
    border: 6px solid #161E31;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    padding: 1px 0px;
    z-index: 4;
    cursor: default;
  }
}

.scene {
  position: relative;
  color: #bfbfbf;
  font-weight: 500;
  cursor: pointer;
  // border: 1px solid #E83B94;
  // border-radius: 30px;
  // margin-right: 5px;

  &:hover {
    color: #E83B94;
  }
}

.sceneNode {
  position: relative;
  cursor: pointer;
  color: #bb809e !important;
  font-weight: 500;

  // &::after {
  //   content: '';
  //   position: absolute;
  //   width: 30px;
  //   height: 2px;
  //   top: 50%;
  //   right: -20px;
  //   background: #E83B94;
  //   border: 6px solid #262626;
  //   -webkit-transform: translateY(-50%);
  //   transform: translateY(-50%);
  //   padding: 1px 0px;
  //   z-index: 4;
  //   cursor: default;
  // }
}

.logic {
  position: relative;
  color: #bfbfbf;
  font-weight: 500;
  cursor: pointer;

  // &::after {
  //   content: '';
  //   position: absolute;
  //   width: 30px;
  //   height: 2px;
  //   top: 50%;
  //   right: -20px;
  //   background: #8debd2;
  //   border: 6px solid #262626;
  //   -webkit-transform: translateY(-50%);
  //   transform: translateY(-50%);
  //   padding: 1px 0px;
  //   z-index: 4;
  //   cursor: default;
  // }

  &:hover {
    color: #8debd2;
  }
}

.logicNode {
  position: relative;
  cursor: pointer;
  color: #8debd2 !important;
  font-weight: 500;

  // &::after {
  //   content: '';
  //   position: absolute;
  //   width: 30px;
  //   height: 2px;
  //   top: 50%;
  //   right: -20px;
  //   background: #8debd2;
  //   border: 6px solid #262626;
  //   -webkit-transform: translateY(-50%);
  //   transform: translateY(-50%);
  //   padding: 1px 0px;
  //   z-index: 4;
  //   cursor: default;
  // }
}

.page {
  position: relative;
  color: #bfbfbf;
  font-weight: 500;
  cursor: pointer;

   &:hover {
    color: #FFA500;
  }
}

.pageNode {
  position: relative;
  cursor: pointer;
  color: #FFA500 !important;
  font-weight: 500;
}

.arrow {
  border-top: 1px solid #EEBA2E;
  border-right: 1px solid #EEBA2E;
  height: 0.4rem;
  width: 0.4rem;
  transform: rotate(50deg);
  margin-right: 0.5rem;
}

.dropbtn {
  position: relative;
  color: #bfbfbf;
  font-weight: 500;
}

.dropdown-content {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #131313;
  width: 85px;
  border-radius: 10px;
  border: 1px solid #e1ba2e;
  padding: 10px 0;

  a {
    width: 100%;
    margin: 5px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 0px;
    color: #E83B94;

    &::after {
    content: none;
  }

    &:hover {
      background-color: #373737;
    }
  }

}

@media  (max-width: 820px) {
  .routeMap_container {
  display: none;
}
}
</style>


// WEBPACK FOOTER //
// src/components/global/RouteMap.vue